/**
 * transport用户信息模块接口列表
 */
import {ApiUrl} from "./configUrl";
import Axios from "./http"
import qs from "qs"

let apiList = {
    /* 获取首页数据 */
    getHomeData(data) {
        return Axios.post(`${ApiUrl}/home/getHomeData`, qs.stringify(data));
    },
    /* 提交用户意见 */
    getFooterSubmit(data) {
        return Axios.post(`${ApiUrl}/lm/add`, qs.stringify(data));
    },
    /* 获取货源列表 */
    getSourceList(data) {
        return Axios.post(`${ApiUrl}/csc/get`, qs.stringify(data));
    },
    /* 获取新闻列表 */
    getNewsList(data) {
        return Axios.post(`${ApiUrl}/news/get`, qs.stringify(data));
    },
    /* 获取新闻详情 */
    getNewsDetails(data) {
        return Axios.post(`${ApiUrl}/news/getdetails`, qs.stringify(data));
    },
    /* 获取合作伙伴列表 */
    getCooperationList(data) {
        return Axios.post(`${ApiUrl}/cp/get`, qs.stringify(data));
    },
    /* 获取合作伙伴列表 */
    getAboutData(data) {
        return Axios.post(`${ApiUrl}/abus/get`, qs.stringify(data));
    },
    /* 联系我们页面banner */
    getSubmitImg(data) {
        return Axios.post(`${ApiUrl}/lm/get`, qs.stringify(data));
    },
    // 手机端获取数据
    getHomeMpData(data) {
        return Axios.post(`${ApiUrl}/cpmp/getHomeData`, qs.stringify(data));
    },

}
export default apiList;
